import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../api/auth';

export default function Nav() {
  const nav = useNavigate();
  const loc = useLocation();
  const { user, logout } = useAuth();

  const links = [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/scenarios', label: 'Scenarios' },
    { path: '/practice',  label: 'Practice' },
  ];

  return (
    <nav style={S.nav}>
      <div style={S.inner}>
        <div style={S.logo} onClick={() => nav('/dashboard')}>
          🎙️ <span style={S.logoText}>Calliope</span>
        </div>
        <div style={S.links}>
          {links.map(l => (
            <button key={l.path} style={{ ...S.link, ...(loc.pathname === l.path ? S.linkActive : {}) }}
              onClick={() => nav(l.path)}>
              {l.label}
            </button>
          ))}
        </div>
        <div style={S.right}>
          <span style={S.userName}>{user?.name}</span>
          <button style={S.logoutBtn} onClick={logout}>Sign out</button>
        </div>
      </div>
    </nav>
  );
}

const S = {
  nav: { background: '#fff', borderBottom: '1px solid #E5E7EB', position: 'sticky', top: 0, zIndex: 100 },
  inner: { maxWidth: 1100, margin: '0 auto', padding: '0 24px', height: 56, display: 'flex', alignItems: 'center', gap: 32 },
  logo: { display: 'flex', alignItems: 'center', gap: 8, fontSize: 18, cursor: 'pointer', flexShrink: 0 },
  logoText: { fontWeight: 700, color: '#111827' },
  links: { display: 'flex', gap: 4, flex: 1 },
  link: { padding: '6px 14px', background: 'transparent', border: 'none', borderRadius: 8, color: '#6B7280', cursor: 'pointer', fontSize: 14, fontWeight: 500 },
  linkActive: { background: '#EFF6FF', color: '#2563EB', fontWeight: 600 },
  right: { display: 'flex', alignItems: 'center', gap: 12, marginLeft: 'auto' },
  userName: { fontSize: 13, color: '#9CA3AF' },
  logoutBtn: { fontSize: 13, color: '#6B7280', background: 'transparent', border: '1px solid #E5E7EB', borderRadius: 6, padding: '5px 12px', cursor: 'pointer' },
};
